import styles from './ClaimsSection.module.css'

function DashMock() {
  const rows = [
    { rank: '01', name: 'Caos Total FC',    gw: '+87', tot: '2.261', mine: false },
    { rank: '02', name: 'Atlético Mock City', gw: '+73', tot: '2.209', mine: false },
    { rank: '03', name: 'Samurai XI · você', gw: '+94', tot: '2.184', mine: true },
    { rank: '04', name: 'Real Lisbon',       gw: '+65', tot: '2.142', mine: false },
    { rank: '05', name: 'FC Bug Report',     gw: '+52', tot: '2.098', mine: false },
  ]
  return (
    <div className={styles.mockDash}>
      <div className={styles.mockDashRow}>
        <div className={styles.mockTile}>
          <div className={styles.mockTileLbl}>PTS · TOTAL</div>
          <div className={`${styles.mockTileVal} ${styles.mockTileValAcc}`}>2.184</div>
        </div>
        <div className={styles.mockTile}>
          <div className={styles.mockTileLbl}>RODADA</div>
          <div className={styles.mockTileVal}>+94</div>
        </div>
        <div className={styles.mockTile}>
          <div className={styles.mockTileLbl}>RANK</div>
          <div className={styles.mockTileVal}>3<span className={styles.mockTileOf}>/240</span></div>
        </div>
      </div>
      <div className={styles.mockTable}>
        <div className={styles.mockTableHeader}>
          <span>LIGA · GRUPO DOS BRABOS</span>
          <span className={styles.mockTableLive}>● AO VIVO</span>
        </div>
        {rows.map((r) => (
          <div key={r.rank} className={`${styles.mockTableRow} ${r.mine ? styles.mockTableRowMine : ''}`}>
            <span className={`${styles.mockTableRank} ${r.mine ? styles.mockTableRankAcc : ''}`}>{r.rank}</span>
            <span className={styles.mockTableName}>{r.name}</span>
            <span className={`${styles.mockTablePts} ${r.mine ? styles.mockTablePtsAcc : ''}`}>{r.gw}</span>
            <span className={styles.mockTableTot}>{r.tot}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

function ConfiguratorMock() {
  return (
    <div className={styles.mockConfig}>
      <div className={styles.mockConfigCol}>
        <div className={styles.mockConfigBlock}>
          <div className={styles.mockConfigLbl}>FORMATO DA LIGA</div>
          <div className={styles.mockConfigOpts}>
            <div className={styles.mockOpt}>
              <span className={styles.mockOptDot} /> Pontos corridos
            </div>
            <div className={`${styles.mockOpt} ${styles.mockOptActive}`}>
              <span className={styles.mockOptDot} /> H2H semanal
            </div>
            <div className={styles.mockOpt}>
              <span className={styles.mockOptDot} /> Sobrevivente
            </div>
          </div>
        </div>

        <div className={styles.mockConfigBlock}>
          <div className={styles.mockConfigLbl}>TRANSFERÊNCIAS / RODADA</div>
          <div className={styles.mockConfigRow}>
            <div className={styles.mockChip}>3 grátis</div>
            <span className={styles.mockHint}>+5pts por extra</span>
          </div>
        </div>

        <div className={styles.mockConfigBlock}>
          <div className={styles.mockConfigLbl}>PRIZE POOL</div>
          <div className={styles.mockPrize}>
            <span className={styles.mockPrizeVal}>R$ 4.800</span>
            <span className={styles.mockPrizeMeta}>R$ 25 × 240 jogadores</span>
          </div>
        </div>
      </div>

      <div className={styles.mockConfigCol}>
        <div className={styles.mockConfigBlock}>
          <div className={styles.mockConfigLbl}>ESQUEMA DE PONTUAÇÃO</div>
          <div className={styles.mockRules}>
            <div className={styles.mockRule}>
              <span>Gol</span><span className={styles.mockRulePts}>+7</span>
            </div>
            <div className={styles.mockRule}>
              <span>Assistência</span><span className={styles.mockRulePts}>+4</span>
            </div>
            <div className={styles.mockRule}>
              <span>Cartão amarelo</span><span className={`${styles.mockRulePts} ${styles.mockRuleNeg}`}>−1</span>
            </div>
            <div className={styles.mockRule}>
              <span>Jogo sem sofrer gol (GK/ZAG)</span><span className={styles.mockRulePts}>+5</span>
            </div>
            <div className={styles.mockRule}>
              <span>Gol contra</span><span className={`${styles.mockRulePts} ${styles.mockRuleNeg}`}>−3</span>
            </div>
            <div className={styles.mockRule}>
              <span>Dribles certos (a cada 5)</span><span className={styles.mockRulePts}>+1</span>
            </div>
            <div className={styles.mockRule}>
              <span>Contribuição defensiva</span><span className={styles.mockRulePts}>+2</span>
            </div>
            <div className={styles.mockRule}>
              <span>Finalização no gol (a cada 3)</span><span className={styles.mockRulePts}>+1</span>
            </div>
            <div className={styles.mockAddRule}>+ adicionar regra customizada</div>
          </div>
        </div>
      </div>
    </div>
  )
}

function SquadMock() {
  const starters = [
    { name: 'Alisson',    top: '88%', left: '50%', cap: false, empty: false },
    { name: 'Marquinhos', top: '68%', left: '20%', cap: false, empty: false },
    { name: 'Silva',      top: '68%', left: '42%', cap: false, empty: false },
    { name: 'Militão',   top: '68%', left: '58%', cap: false, empty: false },
    { name: 'Vanderson',  top: '68%', left: '80%', cap: false, empty: false },
    { name: 'Casemiro',   top: '42%', left: '30%', cap: false, empty: false },
    { name: 'Maya',       top: '42%', left: '50%', cap: true,  empty: false },
    { name: 'Paquetá',   top: '42%', left: '70%', cap: false, empty: false },
    { name: 'Vini Jr',    top: '18%', left: '30%', cap: false, empty: false },
    { name: 'Kléber',    top: '18%', left: '50%', cap: false, empty: false },
    { name: '+ vaga',     top: '18%', left: '70%', cap: false, empty: true },
  ]
  const plist = [
    { pos: 'ATA', name: 'R. Borja',   pts: '8.4' },
    { pos: 'ATA', name: 'P. Vegetti', pts: '7.9' },
    { pos: 'ATA', name: 'G. Sara',    pts: '7.6' },
    { pos: 'ATA', name: 'L. Suárez', pts: '7.2' },
    { pos: 'ATA', name: 'M. Calleri', pts: '6.8' },
  ]
  return (
    <div className={styles.mockSquad}>
      <div className={styles.miniPitch}>
        <div className={styles.miniCircle} />
        {starters.map((s, i) => (
          <div
            key={i}
            className={`${styles.pSpot} ${s.empty ? styles.pSpotEmpty : ''} ${s.cap ? styles.pSpotCap : ''}`}
            style={{ top: s.top, left: s.left }}
          >
            <div className={styles.pHead} />
            <div className={`${styles.pName} ${s.empty ? styles.pNameEmpty : ''}`}>{s.name}</div>
          </div>
        ))}
      </div>
      <div className={styles.pList}>
        <div className={styles.pListHead}>
          <span>ADD ATA</span><span>PTS/JG</span>
        </div>
        {plist.map((p) => (
          <div key={p.name} className={styles.pListRow}>
            <span className={styles.pListPos}>{p.pos}</span>
            <span className={styles.pListName}>{p.name}</span>
            <span className={styles.pListPts}>{p.pts}</span>
            <span className={styles.pListAdd}>+</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export function ClaimsSection() {
  return (
    <section className={styles.section} style={{ paddingTop: 0 }}>
      <div className={styles.sectionHead}>
        <div>
          <div className={styles.num}>03 / DENTRO DO PRODUTO</div>
          <h2 className={styles.heading}>
            Painel que <span className={styles.glow}>não esconde</span> nada.
          </h2>
        </div>
        <div className={styles.headRight}>
          Cada número visível, cada lance contextualizado, cada decisão a um clique de distância.
        </div>
      </div>

      <div className={styles.showcase}>
        <div className={styles.shot}>
          <div className={styles.shotTag}>DASHBOARD</div>
          <DashMock />
          <div className={styles.shotCaption}>
            <h4 className={styles.shotCaptionTitle}>Dashboard em fluxo</h4>
            <p className={styles.shotCaptionDesc}>
              Posição na liga, pontos do round e jogos ao vivo num único painel. Atualiza enquanto a bola rola.
            </p>
          </div>
        </div>

        <div className={styles.shot}>
          <div className={`${styles.shotTag} ${styles.shotTagGold}`}>SQUAD PICKER</div>
          <SquadMock />
          <div className={styles.shotCaption}>
            <h4 className={styles.shotCaptionTitle}>Pitch + lista, lado a lado</h4>
            <p className={styles.shotCaptionDesc}>
              Vê o time inteiro montado e a lista de candidatos sem abrir modal. Click → preenche → confirma.
            </p>
          </div>
        </div>

        <div className={`${styles.shot} ${styles.shotWide}`}>
          <div className={`${styles.shotTag} ${styles.shotTagAcc}`}>CONFIGURADOR DE LIGA · ADMIN</div>
          <ConfiguratorMock />
          <div className={styles.shotCaption}>
            <h4 className={styles.shotCaptionTitle}>Você é o comissário</h4>
            <p className={styles.shotCaptionDesc}>
              Escolhe o formato, ajusta cada pontuação evento por evento, define o prize pool e as regras de
              transferência. Cada liga é um produto seu — a gente só fornece a engine.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
